import { Category } from "./filters"

export const DEADLINE_CATEGORIES: { [key: string]: Category } = {
  deadlineDans: "Dans",
  deadlineDJ: "DJ",
  deadlineExpo: "Expo",
  deadlineFashion: "Fashion",
  deadlineFilm: "Film",
  deadlineMuziek: "Muziek",
  deadlineTaal: "Taal",
  deadlineTheater: "Theater",
}
